import React from 'react'
import { pdf } from '../../assets/pdf'

export const ViewerPdf = () => {
    return (
        <div className="flex w-full min-w-[450px] h-full ">
            <iframe id="mainContainer" className='transform -translate-y-9 ' title='pdf' src={pdf.manulVRL + "#view=FitH&toolbar=0&navpanes=0"} width="100%" height="100%" ></iframe>
        </div>

    )
}
